<template>
  <AppProvider>
    <NEl>
      <div class="app-container">
        <RouterView />
      </div>
    </NEl>
  </AppProvider>
</template>

<script setup lang="ts">
import AppProvider from './components/AppProvider/index.vue'
import { NEl } from 'naive-ui'
</script>

<style>
@import 'tailwindcss';
body {
  margin: 0 !important;
  padding: 0 !important;
  height: 100vh;
}

.content-wrap {
  max-width: 1280px;
  margin: 0 auto;
}
</style>
